
const state = {
  // 用户数据
  alreadyWalletConnected: false
}

export default state
